import { Unit } from './unit.model';
export class CheckAvailability{
    id:number;
    date: Date;
    dateStr : string;
    units: Unit[];
}